import * as CSS from "csstype";
import * as React from "react";
import { IBaseSectionProps, IUserProfileDetails } from "./Sections";
import { Button } from "@metricell/smarttoolscore";
import { RegisterPasskeyEmailForm } from "../../LoginPages/RegisterPasskeyEmailForm";

export interface IUserProfileTowerProps extends IBaseSectionProps {
    profile: IUserProfileDetails;
    updateProfile: () => Promise<void>;
    isPasskeyAuthenticationEnabled: string;
}

export class UserProfileTower extends React.Component<IUserProfileTowerProps> {
    /** Renders the profile image in a read only format */
    private readonly _renderReadOnlyProfileImage = (): React.ReactNode => {
        // Profile image
        const profileAttribute: CSS.Properties = {
            backgroundImage: this.props.profile.icon
                ? `url("${this.props.profile.icon}")`
                : null,
        };

        return (
            <div className={`profile-imagecontainer`}>
                <div
                    className={`imagecontainer-image`}
                    style={profileAttribute}
                />
                <div className={`imagecontainer-border`} />
            </div>
        );
    };

    /** Renders the profile details as a read only view */
    private readonly _renderReadOnlyProfileDetails = (): React.ReactNode => {
        const missingData = `Not Provided`;

        const name = `${this.props.profile.firstName ?? ``} ${
            this.props.profile.lastName ?? ``
        }`;

        return (
            <div className={`profile-properties`}>
                <div className={`properties-propertygroup`}>
                    <span className={`propertygroup-propertytitle`}>
                        Username
                    </span>
                    <span className={`propertygroup-property`}>
                        {this.props.profile.username}
                    </span>
                </div>
                <div className={`properties-propertygroup`}>
                    <span className={`propertygroup-propertytitle`}>Name</span>
                    <span className={`propertygroup-property`}>
                        {name.trim() !== `` ? name : missingData}
                    </span>
                </div>
                <div className={`properties-propertygroup`}>
                    <span className={`propertygroup-propertytitle`}>Email</span>
                    <span className={`propertygroup-property`}>
                        {this.props.profile.email}
                    </span>
                </div>
                <div className={`properties-propertygroup`}>
                    <span className={`propertygroup-propertytitle`}>
                        Telephone Number
                    </span>
                    <span className={`propertygroup-property`}>
                        {this.props.profile.phoneNumber || missingData}
                    </span>
                </div>
                <div className={`properties-propertygroup`}>
                    <span className={`propertygroup-propertytitle`}>
                        Job Title
                    </span>
                    <span className={`propertygroup-property`}>
                        {this.props.profile.userTitle || missingData}
                    </span>
                </div>
                <div className={`properties-propertygroup`}>
                    <span className={`propertygroup-propertytitle`}>
                        Department
                    </span>
                    <span className={`propertygroup-property`}>
                        {this.props.profile.department || missingData}
                    </span>
                </div>
            </div>
        );
    };

    private readonly _renderEditProfile = (): React.ReactNode => (
        <div className={`profile-editprofilecontainer`}>
            <div className={`editprofile-button-margin`}>
                <Button
                    href={`/EditProfile?ReturnURL=${window.location.pathname.replace(
                        /\//g,
                        `%2f`,
                    )}`}
                    type={`primary`}
                >
                    Edit Profile
                </Button>
            </div>
        </div>
    );

    private readonly _renderPasskeyRegsitration = (): React.ReactNode => (
        <div className={`profile-editprofilecontainer`}>
            <div className={`editprofile-button-margin`}>
                <RegisterPasskeyEmailForm
                    userName={this.props.profile.username}
                />
            </div>
        </div>
    );

    private readonly _renderManagePasskey = (): React.ReactNode => (
        <div className={`profile-editprofilecontainer`}>
            <div className={`editprofile-button-margin`}>
                <Button
                    href={`/EditPasskeys?ReturnURL=${window.location.pathname.replace(
                        /\//g,
                        `%2f`,
                    )}`}
                    type={`primary`}
                >
                    Manange Passkeys
                </Button>
            </div>
        </div>
    );

    public render(): React.ReactNode {
        // Render profile image
        const profileImage: React.ReactNode =
            this._renderReadOnlyProfileImage();

        // Render profile details
        const profileDetails: React.ReactNode =
            this._renderReadOnlyProfileDetails();

        // Render passkey create button
        const passkeyCreate: React.ReactNode =
            this._renderPasskeyRegsitration();

        // Render passkey manage button
        const passkeyManange: React.ReactNode = this._renderManagePasskey();

        const editProfile: React.ReactNode = this._renderEditProfile();

        return (
            <div className={`navtower-profile`}>
                {profileImage}
                {profileDetails}
                {editProfile}
                {this.props.isPasskeyAuthenticationEnabled && passkeyCreate}
                {this.props.isPasskeyAuthenticationEnabled && passkeyManange}
            </div>
        );
    }
}
